<a id="btnDownload" class="d-none" href="javascript:void('');" download>DownloadFakeBtn</a>
<div class="page">
    <div class="page-padding">
        <div class="page-header-custom">
            <h1 class="page-title">{{'caronasolidaria' | translate}} | <span>{{'historico' | translate}}</span></h1>
            <div class="d-flex flex-wrap" style="gap: 20px">
                <app-dashboard-button *ngIf="viewDashboard" [route]="'/dashboard-carpool'"></app-dashboard-button>
                <a class="btn btn-gray-fill flex-grow-1" (click)="actionExcel()">
                    <svg-icon class="right" src="assets/svg/downloads.svg"></svg-icon>
                    {{'exportarexcel'|translate}}
                </a>
                <a class="btn btn-warning flex-grow-1" (click)="openManualEntry()">
                    <svg-icon src="assets/svg/plus-circle.svg"></svg-icon>
                    {{'registrarentradamanual' | translate}}
                </a>
            </div>
        </div>

        <!-- Filtros -->
        <div class="page-filter">
            <div class="input-material">
                <input [(ngModel)]="filter.keyword" id="keyword" name="keyword" class="form-control" type="text"/>
                <label for="keyword">{{'busca' | translate}}</label>
            </div>
            <div class="input-material">
                <input id="caronaRange" class="form-control carona-daterange" type="text"/>
                <label for="caronaRange">{{'periodo' | translate}}</label>
            </div>
            <div class="input-material select">
                <select name="status" id="status" [(ngModel)]="filter.status" class="form-control">
                    <option [ngValue]="undefined">{{'all' | translate}}</option>
                    <option value="inside">{{'dentro' | translate}}</option>
                    <option value="exited">{{'saiu' | translate}}</option>
                </select>
                <label for="status">{{'settings.status' | translate}}</label>
            </div>
            <a (click)="onFilter()" class="btn btn-primary btn-lg text-white">{{'buscar' | translate}}</a>
            <a href="javascript:void(0)" (click)="clearFilter()" class="btn btn-secondary btn-lg text-white" type="button">
                <span>{{'limpar' | translate}}</span>
            </a>
        </div>

        <!-- Tabela -->
        <div class="table-responsive">
            <table class="table table_regular">
                <thead>
                <tr>
                    <th scope="col">{{'colaborador' | translate}}</th>
                    <th scope="col">RE</th>
                    <th scope="col">{{'placa' | translate}}</th>
                    <th scope="col">{{'bloc' | translate}}</th>
                    <th scope="col">{{'vaga' | translate}}</th>
                    <th scope="col">{{'unidade' | translate}}</th>
                    <th class="text-center" scope="col">{{'entrada' | translate}}</th>
                    <th class="text-center" scope="col">{{'saida' | translate}}</th>
                    <th class="text-center" scope="col">{{'settings.status' | translate}}</th>
                    <th scope="col">{{'vigilanteentrada' | translate}}</th>
                    <th scope="col">{{'vigilantesaida' | translate}}</th>
                    <th class="text-center" scope="col">{{'acoes' | translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="text-center" *ngIf="isNullOrUndefined(result?.results)">
                    <td colspan="12" class="text-center">{{'nenhumregistro' | translate}}</td>
                </tr>
                <tr *ngFor="let r of result.results |
                    paginate: {itemsPerPage: result.PageSize,
                    currentPage: result.currentPage,
                    totalItems: result.totalCount }">
                    <td>{{ r.employeeName ? r.employeeName : '-' }}</td>
                    <td>{{ r.re }}</td>
                    <td class="text-uppercase">{{ r.licensePlate }}</td>
                    <td>{{ r.bloc?.name }}</td>
                    <td>{{ r.vaga ? r.vaga : '-' }}</td>
                    <td>{{ r.unity?.name }}</td>
                    <td class="text-center">{{ r.entryAt | date:'dd/MM/yyyy HH:mm' }}</td>
                    <td class="text-center">{{ r.exitAt ? (r.exitAt | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
                    <td class="text-center">
                        <span class="badge"
                              [ngClass]="r.status === 'inside' ? 'badge-success' : 'badge-secondary'">
                            {{ (r.status === 'inside' ? 'dentro' : 'saiu') | translate }}
                        </span>
                    </td>
                    <td>{{ r.entryBy?.name }}</td>
                    <td>{{ r.exitBy?.name }}</td>
                    <td class="text-center">
                        <a *ngIf="r.status === 'inside'" href="javascript:void(0)"
                           (click)="openManualExit(r)" title="{{'saidamanual' | translate}}">
                            <svg-icon src="assets/svg/edit.svg" style="cursor: pointer"></svg-icon>
                        </a>
                        <span *ngIf="r.status !== 'inside'" class="text-muted">—</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="text-right">
            <pagination-controls
                    [previousLabel]="labels.previousLabel"
                    [nextLabel]="labels.nextLabel"
                    [screenReaderPaginationLabel]="labels.screenReaderPaginationLabel"
                    [screenReaderPageLabel]="labels.screenReaderPageLabel"
                    [screenReaderCurrentLabel]="labels.screenReaderCurrentLabel"
                    (pageChange)="pageChanged($event)"></pagination-controls>
        </div>
    </div>
</div>

<!-- MODAL SAÍDA MANUAL (por linha, registro 'inside') -->
<div class="modal fade" id="historyManualExitModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content p-0">
            <div class="modal-header">
                <h5 class="modal-title text-primary">{{'saidamanual' | translate}}</h5>
                <button type="button" class="pt-0" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">X</span></button>
            </div>
            <div class="modal-body">
                <p class="text-muted">{{'correcaomanual' | translate}}</p>
                <div class="card p-2 mb-3" style="background-color:#F5F3EC">
                    <p class="mb-0"><strong>{{'colaborador' | translate}}:</strong> {{ manualExit.recordLabel }}</p>
                </div>
                <div class="row">
                    <div class="col-12 mb-3">
                        <label class="d-block mb-1">{{'datahorasaida' | translate}}</label>
                        <input class="form-control w-100" type="datetime-local" [(ngModel)]="manualExit.exitAt"/>
                    </div>
                    <div class="col-12 mb-3">
                        <label class="d-block mb-1">*{{'justificativa' | translate}}</label>
                        <textarea class="form-control w-100" rows="2" [(ngModel)]="manualExit.exitNote"></textarea>
                    </div>
                    <div class="col-12">
                        <a (click)="submitManualExit()" class="btn btn-primary w-100">{{'registrarsaidamanual' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- MODAL ENTRADA MANUAL (botão geral do topo) -->
<div class="modal fade" id="historyManualEntryModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content p-0">
            <div class="modal-header">
                <h5 class="modal-title text-primary">{{'entradamanual' | translate}}</h5>
                <button type="button" class="pt-0" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">X</span></button>
            </div>
            <div class="modal-body">
                <p class="text-muted">{{'correcaomanual' | translate}}</p>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label class="d-block mb-1">{{'nome' | translate}}</label>
                        <input class="form-control w-100 text-uppercase" type="text" [(ngModel)]="manualEntry.employeeName" maxlength="255"/>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="d-block mb-1">*RE</label>
                        <input class="form-control w-100 text-uppercase" type="text" [(ngModel)]="manualEntry.re" maxlength="255"/>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="d-block mb-1">*{{'placa' | translate}}</label>
                        <input class="form-control w-100 text-uppercase" type="text" [(ngModel)]="manualEntry.licensePlate" maxlength="7"/>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="d-block mb-1">*{{'bloc' | translate}}</label>
                        <select class="form-control w-100" [(ngModel)]="manualEntry.blocId">
                            <option [ngValue]="null">{{'selecione' | translate}}</option>
                            <option *ngFor="let b of blocs" [ngValue]="b.bloc.id">
                                {{ b.bloc.name }} ({{ b.available }}/{{ b.capacity }})
                            </option>
                        </select>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="d-block mb-1">{{'vaga' | translate}}</label>
                        <input class="form-control w-100 text-uppercase" type="text" [(ngModel)]="manualEntry.vaga" maxlength="50"/>
                    </div>
                    <div class="col-12 mb-3">
                        <label class="d-block mb-1">{{'datahoraentrada' | translate}}</label>
                        <input class="form-control w-100 text-uppercase" type="datetime-local" [(ngModel)]="manualEntry.entryAt"/>
                    </div>
                    <div class="col-12 mb-3">
                        <label class="d-block mb-1">*{{'justificativa' | translate}}</label>
                        <textarea class="form-control w-100 text-uppercase" rows="2" [(ngModel)]="manualEntry.entryNote"></textarea>
                    </div>
                    <div class="col-12">
                        <a (click)="submitManualEntry()" class="btn btn-primary w-100">{{'registrarentradamanual' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
